import { axiosV2 } from "config/@axios";

import * as uiActions from "store/actions/uiActions";
import * as contactUiActions from "pages/Contacts/store/uiActions";
import i18next from "i18next";

export const FETCH_TAGS = "Contacts->tagActions::fetchTags";
export const FETCH_TAGS_PENDING = "Contacts->tagActions::fetchTagsPending";
export const FETCH_TAGS_SUCCESS =
  "Contacts->tagActions:fetchTagsPendingSuccess";
export const FETCH_TAGS_FAILED = "Contacts->tagActions::fetchTagsPendingFailed";

export const CREATE_TAG_PENDING = "Contacts->tagActions::createTagPending";
export const CREATE_TAG_FAILED = "Contacts->tagActions::createTagFailed";
export const CREATE_TAG_SUCCESS = "Contacts->tagActions::createTagSuccess";

export const OPEN_CREATE_MODAL = "Contacts->tagActions::openCreateModal";
export const CLOSE_CREATE_MODAL = "Contacts->tagActions::closeCreateModal";

export const DELETE_TAG = "Contacts->tagActions::deleteTag";
export const DELETE_TAG_PENDING = "Contacts->tagActions::deleteTagPending";
export const DELETE_TAG_SUCCESS = "Contacts->tagActions::deleteTagSuccess";
export const DELETE_TAG_FAILED = "Contacts->tagActions::deleteTagFailed";

export const UPDATE_TAG = "Contacts->tagActions::updateTag";
export const UPDATE_TAG_PENDING = "Contacts->tagActions::updateTagPending";
export const UPDATE_TAG_SUCCESS = "Contacts->tagActions::updateTagSuccess";
export const UPDATE_TAG_FAILED = "Contacts->tagActions::updateTagFailed";

export const fetchTags = () => dispatch => {
  dispatch({
    type: FETCH_TAGS_PENDING
  });
  return axiosV2
    .get("/tags")
    .then(response => {
      dispatch({
        type: FETCH_TAGS_SUCCESS,
        payload: response.data
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_TAGS_FAILED,
        payload: err?.errorMessage
      });
    });
};

export const createTag = payload => dispatch => {
  dispatch({
    type: CREATE_TAG_PENDING
  });

  return axiosV2
    .post("/tags", payload)
    .then(response => {
      dispatch({
        type: CREATE_TAG_SUCCESS,
        payload: response.data
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("contacts:messages.tag_create_success")
        })
      );
      dispatch(closeCreateModal());
    })
    .catch(err => {
      dispatch({
        type: CREATE_TAG_FAILED,
        payload: err?.errorMessage
      });
    });
};

export const deleteTag = payload => dispatch => {
  dispatch({
    type: DELETE_TAG_PENDING
  });
  return axiosV2
    .delete(`/tags/${payload.id}`)
    .then(() => {
      dispatch({
        type: DELETE_TAG_SUCCESS,
        payload: payload.id
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("contacts:messages.tag_delete_success")
        })
      );
    })
    .catch(err => {
      dispatch({
        type: DELETE_TAG_FAILED,
        payload: err?.errorMessage
      });
    });
};

export const updateTag = payload => dispatch => {
  dispatch({
    type: UPDATE_TAG_PENDING
  });
  return axiosV2
    .put(`/tags/${payload.id}`, payload)
    .then(() => {
      dispatch(contactUiActions.fetchContacts({ start: 0, count: 15 }));
      dispatch({
        type: UPDATE_TAG_SUCCESS,
        payload: payload
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("contacts:messages.tag_update_success")
        })
      );
      dispatch(closeCreateModal());
    })
    .catch(err => {
      dispatch({
        type: UPDATE_TAG_FAILED,
        payload: err?.errorMessage
      });
    });
};

export const openCreateModal = (status, id = null) => ({
  type: OPEN_CREATE_MODAL,
  payload: {
    status,
    id
  }
});
export const closeCreateModal = () => ({ type: CLOSE_CREATE_MODAL });
